import DOMPurify from 'dompurify'
import { trim } from 'lodash'

export function removeMarkup(label: string): string {
  return trim(
    DOMPurify.sanitize(label, {
      ALLOWED_TAGS: [],
      SAFE_FOR_TEMPLATES: true,
      KEEP_CONTENT: true
    }).replace(/&amp;/g, '&')
  )
}
